export default "__VITE_ASSET__a114dd5d__"